import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CredentialsService, LocalizationService } from '@app/core';
import { VINTERADMIN, vinterOrganizationGuid } from '@app/shared/common/constants';
import { QuestionExpectedAnswerType, EQuestionCollectionLanguages, QuestionCollectionCategoryEnum, EQuestionCollectionSubCategory, AddQuestionShownType, EQuestionContentURLType, EQuestionCategories, OrganizationEnum, EFormType, EStepDurationType, LanguageEnum, ESuggestedPackageType } from '@app/shared/common/enums';
import { AppInfoService } from '@app/shared/services/app-info.services';
import { QuestionListItem } from '@app/vinter/models/question-list-item';
import { SelectedQuestionCollectionItem } from '@app/vinter/models/shared/selected-question-collection-item';
import { QuestionCollectionService } from '@app/vinter/services/question-collection.service';
import { ElementRef } from '@angular/core';
import { QuestionContentListItem } from '@app/vinter/models/question-content-list-item';
import { ChoiceContentListItem } from '@app/vinter/models/choice-content-list-item';
import { FormBuilder,FormGroup} from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
    selector: 'app-select-questions',
    templateUrl: './select-questions.component.html',
    styleUrls: ['./select-questions.component.scss']
})
export class SelectQuestionsComponent implements OnChanges {
    emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
    sourceQuestions: QuestionListItem[] = [];
    targetQuestions: QuestionListItem[] = [];
    tempSourceQuestions: QuestionListItem[] = [];
    vinterGuid: string;
    questionsCopyTest: QuestionListItem;
    questionsCopyTest2: QuestionListItem;
    VideoAnswerType: number;
    MultipleChoiceAnswerType: number;
    OpenEndedAnswerType: number;
    openEndedAnswerCount: number = 0;
    videoAnswerCount: number = 0;
    codingAnswerCount: number = 0;
    multipleChoiceAnswerCount: number = 0;
    imgPath: string = "assets/demo/images/vinter/vinterlogo.jpg";
    selectedItems: boolean[] = [];
    selectAllItems: boolean = false;
    questionCollectionCategories: any[] = [];
    checkboxDisabled: boolean = true;
    isPersonalityOrLanguageSelected: boolean = false;
    selectedLanguageDisplay: string = '';
    QuestionContentType = EQuestionContentURLType;

    questionExpectedAnswerTypeEnum = QuestionExpectedAnswerType;
    questionCollectionCategoryEnum = QuestionCollectionCategoryEnum;
    eQuestionCollectionSubCategory = EQuestionCollectionSubCategory;
    eQuestionCollectionLanguages = EQuestionCollectionLanguages;
    OCEAN50: number = EQuestionCollectionSubCategory.OCEAN50;
    OCEAN120: number = EQuestionCollectionSubCategory.OCEAN120;
    VinterOrganization = OrganizationEnum.Vinter;
    formTypeEnum = EFormType;
    stepDurationTypeEnum = EStepDurationType;

    isOceanSelected: boolean = false;
    isVinterAdminLogged: boolean;
    userGroup: string[] = [];
    showQuestions: boolean = true;
    questionCategoryType = EQuestionCategories;
    isLanguageSelected: boolean = false;
    writingCount: string;
    readingCount: string;
    listeningCount: string;
    vocabularyCount: string;
    grammerCount: string;
    speakingCount: string;
    categoryName: string;
    showMoreText: boolean = false;
    duration: number;
    questionListDuration: number;
    viewQuestionListDuration: number;
    isShowLicensePlanPopup: boolean
    suggestedPackageType = ESuggestedPackageType.Coding

    @Input() selectedLanguage: any;
    @Input() addQuestionShownType: AddQuestionShownType;
    @Input() positionStepDescription;
    @Input() questionList;
    @Input() positionStepQuestionCollectionId;
    @Input() positionStepSubCategory;
    @Input() showDeprecatedQuestions: boolean;
    @Input() generalAppQuestions;
    @Input() selectedQuestionList: SelectedQuestionCollectionItem;
    @Input() yourQuestionListTitle: string;
    @Input() formType: number;
    @Input() isFromEditCurrent: boolean;
    @Input() yourQuestionListDescription: string;
    @Input() yourQuestionListDuration: number;
    @Input() selectedQuestions: QuestionListItem[];
    @Input() selectedQuestionCategory: any;
    @Input() createdQuestionList: any = [];
    @Input() questionCollectionSubCategory;
    languageId: string;
    isTurkish: boolean;
    @Input() stepDurationType: any;
    isCodingQuestionLicenseValid = false;
    isCodingQuestionLicensePending = false;
    questionCollectionLanguageList: any[] = [];

    @Output() saveQuestionsForQuestionList: EventEmitter<QuestionListItem[]> = new EventEmitter<QuestionListItem[]>();
    @Output() saveCreatedQuestionList: EventEmitter<QuestionListItem[]> = new EventEmitter<QuestionListItem[]>();
    @Output() saveQuestionListInfo: EventEmitter<any> = new EventEmitter<any>();

    @Output() saveQuestionListCategory: EventEmitter<string> = new EventEmitter<string>();
    @Output() saveQuestionListSubCategory: EventEmitter<number> = new EventEmitter<number>();
    @Output() closeSubStep: EventEmitter<any> = new EventEmitter<any>();
    @Output() editCustomQuestion: EventEmitter<QuestionListItem> = new EventEmitter<QuestionListItem>();


    categoryColorArray = [
        { label: QuestionCollectionCategoryEnum.TechnicalTest, 'backgroundColor': '#CFDBF9', 'textColor': '#2962FF' },
        { label: QuestionCollectionCategoryEnum.PersonalityTest, 'backgroundColor': '#FFF4D9', 'textColor': '#EFAC00' },
        { label: QuestionCollectionCategoryEnum.Custom, 'backgroundColor': '#FFDCDC', 'textColor': '#FF5454' },
        { label: QuestionCollectionCategoryEnum.CompetenceTest, 'backgroundColor': '#D0F9CF', 'textColor': '#32C52F' },
        { label: QuestionCollectionCategoryEnum.ForeignLanguage, 'backgroundColor': '#EBE2FA', 'textColor': '#722DDE' },
        { label: QuestionCollectionCategoryEnum.Pronunciation, 'backgroundColor': '#EBE2FA', 'textColor': '#722DDE' },
        { label: QuestionCollectionCategoryEnum.CognitiveAbility, 'backgroundColor': '#FFD9C0', 'textColor': '#FF8027' },
        { label: QuestionCollectionCategoryEnum.MTCompetenceTest, 'backgroundColor': '#D0F9CF', 'textColor': '#32C52F' },
        { label: QuestionCollectionCategoryEnum.Coding, 'backgroundColor': '#C5FDF5', 'textColor': '#16B7CC' },
        { label: QuestionCollectionCategoryEnum.CaseStudy, 'backgroundColor': '#FDE7F3', 'textColor': '#C2338A' }
    ];

    tempDurations: { [key: string]: { duration: number, weight: number } } = {};
    editingQuestions: { [key: string]: { duration: boolean, weight: boolean } } = {};

    constructor(
        private service: QuestionCollectionService,
        private appInfoService: AppInfoService,
        public credentialService: CredentialsService,
        public localizationService: LocalizationService,
        private messageService: MessageService,
        public router: Router
    ) {}

    ngOnInit(): void {
        this.languageId = this.credentialService.getLanguage();
        this.isTurkish = this.languageId === LanguageEnum.TurkishTurkey;
        this.isCodingQuestionLicenseValid = this.credentialService.getIsExistCodingQuestionLicense();
        this.isCodingQuestionLicensePending = this.credentialService.getIsCodingLicensePending();
        if(this.selectedQuestionCategory!=null && this.selectedQuestionCategory !== undefined)
            this.categoryName = this.appInfoService.getQuestionCollectionCategoryArray().find(x => x.id === this.selectedQuestionCategory)?.name;
        this.userGroup = this.credentialService.getUserGroups().split(',');
        if (this.userGroup.some(s => s.includes(VINTERADMIN)))
            this.isVinterAdminLogged = true;
        else
            this.isVinterAdminLogged = false;
        this.setSelectedLangDisplay();
        this.VideoAnswerType = QuestionExpectedAnswerType.Video;
        this.MultipleChoiceAnswerType = QuestionExpectedAnswerType.MultipleChoice;
        this.OpenEndedAnswerType = QuestionExpectedAnswerType.OpenEnded;
        this.vinterGuid = vinterOrganizationGuid;
        this.fillYourQuestionListWithSelectedQuestions();
        this.getQuestionsOfQuestionList(this.addQuestionShownType === AddQuestionShownType.PreviewCurrent ? null : this.selectedQuestionList.id);
        this.selectQuestionCategory();
        this.setOceanStaticQuestions();
        this.setOceanStaticAnswer();
        this.initializeTempDurations(this.targetQuestions);
        this.initializeEditingStates(this.targetQuestions);
        this.calculateTotalDuration();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedQuestions && !changes.selectedQuestions.firstChange) {
            this.initializeTempDurations(this.targetQuestions);
            this.initializeEditingStates(this.targetQuestions);
            this.calculateTotalDuration();
        }
    }

    setSelectedLangDisplay(){
        this.questionCollectionLanguageList = this.appInfoService.getQuestionCollectionLanguageList();
        // Dil henüz belirlenmemişse (ör. ilk soru eklenmeden önizleme açıldıysa) panel kırılmasın.
        this.selectedLanguageDisplay = this.questionCollectionLanguageList.find(x => x.id === this.selectedLanguage)?.name ?? '';
    }
    initializeTempDurations(questions) {
        if (!questions || questions.length === 0) {
            return;
        }
                
        questions.forEach(question => {
            if (!question) {
                return;
            }
            
            const questionId = question.id || question.dummyID;
            if (!questionId) {
                return;
            }
            
            // Süre değeri yoksa 0 olarak ayarla
            const duration = question.duration || 0;
            // Ağırlık değeri yoksa 3 olarak ayarla (varsayılan değer)
            const weight = question.weight || 3;
            
            this.tempDurations[questionId] = { duration, weight };
        });
    } 
    initializeEditingStates(questions) {
        if (!questions || questions.length === 0) {
            return;
        }
        
        questions.forEach(question => {
            if (!question) {
                return;
            }
            
            const questionId = question.id || question.dummyID;
            if (!questionId) {
                return;
            }
            
            this.editingQuestions[questionId] = { duration: false, weight: false };
        });
    }
    editDuration(questionId){
        this.editingQuestions[questionId].duration = !this.editingQuestions[questionId].duration;
    }
    saveDuration(questionId){
        if (this.tempDurations[questionId] !== undefined && this.tempDurations[questionId].duration > 0) {
            // Düzenleme durumunda
            if(this.isFromEditCurrent){
                const targetQuestion = this.targetQuestions.find(x => x.id == questionId || x.dummyID == questionId);
                if (targetQuestion) {
                    targetQuestion.duration = this.tempDurations[questionId].duration;
                }
            }
            // Normal durumda
            else{
                // targetQuestions'da soruyu bul
                const targetQuestion = this.targetQuestions.find(x => x.id == questionId || x.dummyID == questionId);
                if (targetQuestion) {
                    targetQuestion.duration = this.tempDurations[questionId].duration;
                }
                // tempSourceQuestions'da soruyu bul
                else {
                    const sourceQuestion = this.tempSourceQuestions.find(x => x.id == questionId || x.dummyID == questionId);
                    if (sourceQuestion) {
                        sourceQuestion.duration = this.tempDurations[questionId].duration;
                    }
                }
            }

            // Düzenleme modunu kapat
            this.editingQuestions[questionId].duration = false;
            
            // Toplam süreyi güncelle
            this.calculateTotalDuration();
        }
    }


    editWeight(questionId){
        this.editingQuestions[questionId].weight = !this.editingQuestions[questionId].weight;
    }
    
    saveWeight(questionId){        
        if (this.tempDurations[questionId] !== undefined) {
            // Ağırlık değerini doğrula (1-5 arasında olmalı)
            this.validateWeight(questionId);
            
            // Düzenleme durumunda
            if(this.isFromEditCurrent){
                const targetQuestion = this.targetQuestions.find(x => x.id == questionId || x.dummyID == questionId);
                if (targetQuestion) {
                    targetQuestion.weight = this.tempDurations[questionId].weight;
                }
            }
            // Normal durumda
            else{
                // targetQuestions'da soruyu bul
                const targetQuestion = this.targetQuestions.find(x => x.id == questionId || x.dummyID == questionId);
                if (targetQuestion) {
                    targetQuestion.weight = this.tempDurations[questionId].weight;
                }
                // tempSourceQuestions'da soruyu bul
                else {
                    const sourceQuestion = this.tempSourceQuestions.find(x => x.id == questionId || x.dummyID == questionId);
                    if (sourceQuestion) {
                        sourceQuestion.weight = this.tempDurations[questionId].weight;
                    }
                }
            }

            // Düzenleme modunu kapat
            this.editingQuestions[questionId].weight = false;
        }
    }

    validateWeight(questionId: string) {
        const weight = this.tempDurations[questionId].weight;

        if (weight < 1) {
          this.tempDurations[questionId].weight = 1;
        } else if (weight > 5) {
          this.tempDurations[questionId].weight = 5;
        }
    }

    removeEmojis(event) {
        this.yourQuestionListTitle = event.replace(this.emojiRegex, '');
    }
      
    preventEmojiInput(event: KeyboardEvent) {
        if (this.emojiRegex.test(event.key)) {
          event.preventDefault();
        }
    }

    onPaste(event: ClipboardEvent) {
        event.preventDefault();
        const clipboardData = event.clipboardData || (window as any).clipboardData;
        let pastedText = clipboardData.getData('text');
        pastedText = pastedText.replace(this.emojiRegex, '');
        document.execCommand('insertText', false, pastedText);
    }
          
    calculateTotalDuration() {
        if (!this.targetQuestions || this.targetQuestions.length === 0) {
            this.questionListDuration = 0;
            return;
        }
                
        // Soruların sürelerini topla, undefined veya null değerler için 0 kullan
        this.questionListDuration = this.targetQuestions.reduce((sum, question) => {
            const duration = question && question.duration ? question.duration : 0;
            return sum + duration;
        }, 0);
    }

    selectQuestionCategory() {
        if (this.selectedQuestionCategory !== null) {
            if ((this.selectedQuestionCategory === QuestionCollectionCategoryEnum.ForeignLanguage && this.questionCollectionSubCategory != EQuestionCollectionSubCategory.SpeakingEnglish)
                || this.selectedQuestionCategory === QuestionCollectionCategoryEnum.PersonalityTest
                || this.selectedQuestionCategory === QuestionCollectionCategoryEnum.Pronunciation
                || this.selectedQuestionCategory === QuestionCollectionCategoryEnum.CognitiveAbility) {
                this.checkboxDisabled = false;
                this.isPersonalityOrLanguageSelected = true;

            }else{
                this.isPersonalityOrLanguageSelected = false;
            }

            if (this.selectedQuestionCategory == QuestionCollectionCategoryEnum.ForeignLanguage)
                 this.isLanguageSelected = true;

            if (this.selectedQuestionCategory === QuestionCollectionCategoryEnum.PersonalityTest && !this.isVinterAdminLogged)
                this.showQuestions = false;

        }
    }


    checkSelectAllStatus() {
        if (this.selectedItems.every(item => item === true)) {
            this.selectAllItems = true;
        } else {
            this.selectAllItems = false;
        }
    }
    getStepStyle(category: any) {
        const categoryItem = this.categoryColorArray.find(item => item.label === this.selectedQuestionCategory);
        return {
          'background-color': categoryItem.backgroundColor,
          'color': categoryItem.textColor
        };
      }
    showQuestionList(subCategory) {
        if (this.isVinterAdminLogged && (subCategory == this.OCEAN50 || subCategory == this.OCEAN120)) {
            this.showQuestions = true;
        }
        else if (!this.isVinterAdminLogged && (subCategory == this.OCEAN50 || subCategory == this.OCEAN120)) {
            this.showQuestions = false;
        }
        else
            this.showQuestions = true;
    }

    getTestCases(jsonData){
        let testcases = JSON.parse(jsonData.toString()).Test_cases;
        return testcases;
    }
    openLicensePlanPopup(){
        if(this.isCodingQuestionLicensePending){
          this.router.navigate(['organization/settings'], {
            queryParams: {
              activeTab: 3,
            }
          });
        }
        else{
          this.isShowLicensePlanPopup = !this.isShowLicensePlanPopup;
        }
      }

    setOceanStaticQuestions() {
        const questionText = this.localizationService.translateText('ExampleOceanQuestion')
        const createQuestion = (showMoreText: boolean) => {
            const question = new QuestionListItem();
            question.showMoreText = showMoreText;
            question.questionContent = new QuestionContentListItem();
            question.questionContent.questionText = questionText;
            question.isDeprecated = false;
            question.expectedAnswerType = this.questionExpectedAnswerTypeEnum.MultipleChoice;
            return question;
        };

        this.questionsCopyTest = createQuestion(false)
        this.questionsCopyTest2 = createQuestion(false)
    }

    setOceanStaticAnswer() {
        const answerTexts = [
            "OceanTestAnswer1",
            "OceanTestAnswer2",
            "OceanTestAnswer3",
            "OceanTestAnswer4",
            "OceanTestAnswer5"
        ];

        this.questionsCopyTest.choiceContents = answerTexts.map(answer => {
            const choice = new ChoiceContentListItem();
            choice.choiceText = this.localizationService.translateText(answer);
            return choice;
        });
    }

    setQuestionCounts() {
        this.openEndedAnswerCount = this.tempSourceQuestions.filter(item => item.expectedAnswerType === QuestionExpectedAnswerType.OpenEnded).length;
        this.videoAnswerCount = this.tempSourceQuestions.filter(item => item.expectedAnswerType === QuestionExpectedAnswerType.Video).length;
        this.multipleChoiceAnswerCount = this.tempSourceQuestions.filter(item => item.expectedAnswerType === QuestionExpectedAnswerType.MultipleChoice).length;
        this.codingAnswerCount = this.tempSourceQuestions.filter(item => item.expectedAnswerType === QuestionExpectedAnswerType.Coding).length;

        if (this.isLanguageSelected) {
            this.writingCount = this.tempSourceQuestions.filter(item => item.questionCategory === this.questionCategoryType.Writing).length.toString();
            this.readingCount = this.tempSourceQuestions.filter(item => item.questionCategory === this.questionCategoryType.Reading).length.toString();
            this.listeningCount = this.tempSourceQuestions.filter(item => item.questionCategory === this.questionCategoryType.Listening).length.toString();
            this.vocabularyCount = this.tempSourceQuestions.filter(item => item.questionCategory === this.questionCategoryType.Vocabulary).length.toString();
            this.grammerCount = this.tempSourceQuestions.filter(item => item.questionCategory === this.questionCategoryType.Grammer).length.toString();
            this.speakingCount = this.tempSourceQuestions.filter(item => item.questionCategory === this.questionCategoryType.Speaking).length.toString();
        }
    }

    getQuestionsOfQuestionList(id: string) {
        if (id ?? false) {
            this.service.GetQuestionCollectionWihtQuestionsChoice(id).subscribe(element => {
                if (element == null) {
                    this.isPersonalityOrLanguageSelected = true;
                    this.showQuestions = false;

                }
                else {
                    element.questions.sort((a, b) => a.order - b.order);
                    this.tempSourceQuestions = [];
                    this.sourceQuestions = element.questions;
                    let index = 0;
                    element.questions.forEach((item) => {
                        if (element.subCategory == EQuestionCollectionSubCategory.OCEAN50 || element.subCategory == EQuestionCollectionSubCategory.OCEAN120) {
                            item.choiceContents.forEach(element => {
                                element.isCorrect = true;
                            });
                        }
                        if (!this.isCodingQuestionLicenseValid && 
                            item.expectedAnswerType == this.questionExpectedAnswerTypeEnum.Coding) {
                            item.questionContent.questionText = this.localizationService.translateText('StaticQuestionText');
                            item.questionContent.contentDetail = "";
                        }
                        if (!item.isDeprecated) {
                            item.langShort = this.getShortLangText(item.languageID);

                            this.tempSourceQuestions.push(item);

                            if (!(this.targetQuestions.find(x => x.id == item.id))) {
                                this.selectedItems[index] = false;
                            } else {
                                this.selectedItems[index] = true;
                            }
                            index++;
                        }
                    });

                    this.tempSourceQuestions[0].showMoreText = false;

                    this.checkSelectAllStatus();
                    this.selectQuestionCategory();
                    this.setQuestionCounts();
                    this.initializeTempDurations(this.tempSourceQuestions);
                    this.initializeEditingStates(this.tempSourceQuestions);
                    this.viewQuestionListDuration = this.tempSourceQuestions.reduce((sum, question) => sum + question.duration, 0);
                }

            });
        } else {
            this.tempSourceQuestions = [];
            this.selectedQuestions.forEach((item, index) => {    
                if (!this.isCodingQuestionLicenseValid && 
                    item.expectedAnswerType == this.questionExpectedAnswerTypeEnum.Coding) {
                    item.questionContent.questionText = this.localizationService.translateText('StaticQuestionText');
                    item.questionContent.contentDetail = "";
                }     
                if (item.isDeprecated != true){
                    item.langShort = this.getShortLangText(item.languageID);
                    this.tempSourceQuestions.push(item);
                }

                this.selectedItems[index] = true;
            });
            if(this.tempSourceQuestions != null && this.tempSourceQuestions != undefined && this.tempSourceQuestions.length > 0)
            this.tempSourceQuestions[0].showMoreText = false;
            this.checkSelectAllStatus();
            this.selectQuestionCategory();
            this.setQuestionCounts();

        }

    }

    getShortLangText(languageID){
        return this.localizationService.getLangShortText(languageID, this.questionCollectionLanguageList);
    }

    sortChoicesByOrder(question) {
        if (question && question.choiceContents) {
            question.choiceContents.sort((a, b) => a.order - b.order);
        }
        return question.choiceContents;
    }

    selectAll(checked: boolean) {
        for (let i = 0; i < this.tempSourceQuestions.length; i++) {
            this.selectedItems[i] = checked;
            const itemIndex = this.targetQuestions.findIndex(x => this.tempSourceQuestions[i] === x);
            const itemIndexYourList = this.createdQuestionList.findIndex(x => this.tempSourceQuestions[i] === x);
            if (checked && itemIndex === -1) {
                if (!this.tempSourceQuestions[i].isDeprecated)
                    this.targetQuestions.push(this.tempSourceQuestions[i]);
            } else if (!checked && itemIndex !== -1) {
                this.targetQuestions.splice(itemIndex, 1);
            }

            if (!checked && itemIndexYourList !== -1) {
                this.createdQuestionList.splice(itemIndex, 1);
            }
        }
    }

    checkChanged(index: number) {
        if (this.selectedItems[index]) {
            this.targetQuestions.push(this.tempSourceQuestions[index]);
        } else {
            if (this.tempSourceQuestions[index].id ?? false) {
                let itemIndex = this.targetQuestions.findIndex(x => this.tempSourceQuestions[index].id === x.id);
                if (itemIndex > -1) {
                    this.targetQuestions.splice(itemIndex, 1);
                }
            } else {
                let itemIndexCreated = this.createdQuestionList.findIndex(x => this.tempSourceQuestions[index] === x);
                let itemIndexTarget = this.targetQuestions.findIndex(x => this.tempSourceQuestions[index] === x);

                if (itemIndexCreated > -1) {
                    this.createdQuestionList.splice(itemIndexCreated, 1);
                }
                if (itemIndexTarget > -1) {
                    this.targetQuestions.splice(itemIndexTarget, 1);
                }
            }

            this.selectAllItems = false;
        }

        if (this.selectedItems.every(item => item === true)) {
            this.selectAllItems = true;
        }
        if(this.isFromEditCurrent){
            this.selectedLanguage = this.checkMultipleLanguage();
        }
        this.setSelectedLangDisplay();
    }

    checkMultipleLanguage(){
        let languageID = this.selectedLanguage;
        if(this.selectedQuestionCategory === QuestionCollectionCategoryEnum.TechnicalTest ||
            this.selectedQuestionCategory === QuestionCollectionCategoryEnum.CompetenceTest ||
            this.selectedQuestionCategory === QuestionCollectionCategoryEnum.MTCompetenceTest) {

            for (let index = 0; index < this.targetQuestions.length; index++) {
                const question = this.targetQuestions[index];
                if(index === 0) {
                    languageID = question.languageID;
                } else if(languageID !== question.languageID) {
                    return EQuestionCollectionLanguages.Multiple;
                }
            }
        }

        return languageID;
    }

    fillYourQuestionListWithSelectedQuestions() {
        this.targetQuestions = this.selectedQuestions.slice();
    }

    moveToSourceEvent(event: any) {
        event.items.forEach(element => {
            if (!(this.sourceQuestions.find(x => x.id == element.id))) {
                const index = this.tempSourceQuestions.indexOf(element, 0);
                this.tempSourceQuestions.splice(index, 1);
            }
        });
    }

    saveQuestionList() {    
        if(this.yourQuestionListTitle.length >= 255){
            this.messageService.add({severity:'error', summary: this.localizationService.translateText('Error'), detail: this.localizationService.translateText('QuestionListTitleMaxLength')});
            return;
        }
        // Kişilik veya dil testi seçiliyse tüm soruları seç
        if (this.isPersonalityOrLanguageSelected) {
            this.selectAll(true);
        }
        
        // Kodlama lisansı yoksa kodlama sorularını filtrele
        if (!this.isCodingQuestionLicenseValid) {
            this.targetQuestions = this.targetQuestions.filter(
                question => question.expectedAnswerType != this.questionExpectedAnswerTypeEnum.Coding
            );
        }
        
        // Soru sürelerini tempDurations'dan güncelle
        this.targetQuestions.forEach(question => {
            const questionId = question.id || question.dummyID;
            if (questionId && this.tempDurations[questionId]) {
                question.duration = this.tempDurations[questionId].duration || 0;
                question.weight = this.tempDurations[questionId].weight || 3;
            }
        });
        
        // Sıralamayı güncelle
        this.updateReorderAllQuestionList(this.targetQuestions);
        
        // Toplam süreyi hesapla
        this.calculateTotalDuration();
        
        // Soruları ve oluşturulan soruları emit et
        this.saveQuestionsForQuestionList.emit(this.targetQuestions);
        this.saveCreatedQuestionList.emit(this.createdQuestionList);
        this.saveQuestionListInfo.emit({ title: this.yourQuestionListTitle, description: this.yourQuestionListDescription, duration: this.questionListDuration})
        if (this.isOceanSelected)
            this.saveQuestionListSubCategory.emit(EQuestionCollectionSubCategory.OCEAN50);
    }

    toggleDisplay(question: any) {
        if(!(!this.isCodingQuestionLicenseValid && question.expectedAnswerType == this.questionExpectedAnswerTypeEnum.Coding)){
        question.showMoreText = !question.showMoreText;
        this.showMoreText = !this.showMoreText;
        }
    }
    
    validateWholeNumber(event: Event): void {
        const input = event.target as HTMLInputElement;
        const value = input.value;
        if (!/^\d*$/.test(value)) {
            input.value = value.replace(/[^0-9]/g, '');
        }
    }

    preventDecimal(event: KeyboardEvent): void {
        if (event.key === '.' || event.key === ',' || event.key === 'Decimal') {
            event.preventDefault();
        }
    }
    
    onReorder(event: any) {
        const oldIndex = event[0].order - 1;
        const questionId = event[0].id;
    
        this.updateReorderAllQuestionList(this.tempSourceQuestions);
        const newOrderIndex = this.getNewOrderIndex(questionId, oldIndex);
    
        this.updateCheckboxOrder(oldIndex, newOrderIndex);
        this.updateSelectedQuestions();
    
        this.fillYourQuestionListWithSelectedQuestions();
    }

    updateReorderAllQuestionList(targetQuestions) {
        targetQuestions.forEach((item, index) => {
            item.order = index + 1;
        });
    }
    getFilteredQuestions(): any[] {
        if(!this.isCodingQuestionLicenseValid){
          return this.tempSourceQuestions.filter(question => 
            question.expectedAnswerType !== this.questionExpectedAnswerTypeEnum.Coding
            );  
        }
        else{
            return this.tempSourceQuestions;
        }
    }
    
    private getNewOrderIndex(questionId: string, oldIndex: number): number {
        const movedQuestion = this.tempSourceQuestions.find(item => item.id === questionId);
        return movedQuestion ? movedQuestion.order - 1 : oldIndex;
    }
    
    private updateCheckboxOrder(oldIndex: number, newOrderIndex: number) {
        const tempCheckboxValue = this.selectedItems[oldIndex];
        const reorderedItems = [...this.selectedItems];
    
        reorderedItems.splice(oldIndex, 1);
        reorderedItems.splice(newOrderIndex, 0, tempCheckboxValue);

        this.selectedItems = reorderedItems;
    }
    
    private updateSelectedQuestions() {
        this.selectedQuestions = this.tempSourceQuestions
            .filter((_, index) => this.selectedItems[index])
            .sort((a, b) => a.order - b.order);
    }
    
    isCustomQuestion(question: QuestionListItem): boolean {
        return !question.originQuestionCollection && question.isCustomQuestion;
    }

    onEditCustomQuestion(question: QuestionListItem): void {
        this.editCustomQuestion.emit(question);
    }
}

